import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

export const categories = {
  namespaced: true,
  state: () => ({
    categories: [], // Store only descriptions
  }),
  mutations: {
    SET_CATEGORIES(state, descriptions) {
      state.categories = descriptions;
    },
  },
  actions: {
    fetchCategories({ commit }) {
      const url = `enums/categories`;
      return this.$axios
        .get(url)
        .then((response) => {
          const categories = response.data.categories;
          commit("SET_CATEGORIES", categories);
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        });
    },
  },
  getters: {},
};
